module.exports = __webpack_public_path__ + "img/cloud-download-alt-solid.1440ed3b.svg";